import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { runtimeEnvironment } from '../../../environments/environment.r';
import { AppState } from '../../store/app.state';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'web-app-update-available-modal',
  templateUrl: './web-app-update-available-modal.page.html',
  styleUrls: ['./web-app-update-available-modal.page.scss'],
  imports: [TranslateModule, IonicModule],
})
export class WebAppUpdateAvailableModalPage implements OnInit {
  url!: string;

  constructor(private appState: AppState) {}

  ngOnInit(): void {
    setTimeout(async () => {
      await this.appState.set({ lastAppUpdateBuildNumber: runtimeEnvironment.BUILD_NUMBER });
      window.location.href = this.url + '?updated=true';
    }, 5000);
  }
}
